import { render, staticRenderFns } from "./DashboardAdminTab1.vue?vue&type=template&id=76375c6e&scoped=true"
import script from "./DashboardAdminTab1.vue?vue&type=script&lang=js"
export * from "./DashboardAdminTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76375c6e",
  null
  
)

export default component.exports